import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import LoginPage from './components/LoginPage';
import OnboardingPage from './components/OnboardingPage';
import BankingDashboard from './components/BankingDashboard';
import InvestmentPage from './components/InvestmentPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/banking" element={<BankingDashboard />} />
          <Route path="/inversion" element={<InvestmentPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;